<template>
  <div>
    <v-card class="mx-auto mt-5 pa-5" max-width="800">
      <v-card-title>
        <div class="title-class">
          <div>
            <strong>{{ `" ${title} " ` }} </strong>
            <span>共找到：</span>
            <strong class="red--text">{{ pageResult.totalCount }}</strong>
            <span>条记录</span>
          </div>
          <div>
            <v-btn-toggle v-model="checked" mandatory @change="btnToggleChange">
              <v-btn v-for="(item,index) in checkList" :key="index">{{ item.name }}</v-btn>
            </v-btn-toggle>
          </div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <div v-for="(item,index) in searchList" :key="index" class="my-5">
        <v-container>
          <v-row justify-center align-center>
            <v-col cols="6" class="d-flex justify-center">
              <div>
                <v-card width="180" height="290">
                  <v-img :src="item.vodPic" class="rounded white--text align-end image-class"
                         gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)">
                    <v-card-title>
                      <div class="text-subtitle-2 text-no-wrap text-truncate">
                        {{ item.vodRemarks }}
                      </div>
                    </v-card-title>
                  </v-img>
                </v-card>
              </div>
            </v-col>
            <v-col cols="6">
              <div>
                <div class="text-subtitle-1 text-no-wrap text-truncate">
                  {{ item.vodName }}
                  <strong class="red--text">
                    {{ item.vodRemarks }}
                  </strong>
                </div>
                <div>
                  <v-container>
                    <v-row>
                      <v-col cols="6">
                        <div>
                          <v-rating
                              half-increments
                              v-model="item.rating"
                              background-color="yellow"
                              color="yellow accent-4"
                              readonly
                              dense
                          ></v-rating>
                        </div>
                      </v-col>
                      <v-col cols="6" class="d-none d-sm-flex and-up">
                        <div class="pt-1">
                              <span class="text--lighten-2 text-md-body-1 mr-2">
                                ({{ item.rating }})
                              </span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
                <div class="mt-2 text-no-wrap text-truncate">
                  分类：{{ item.typeName }}
                </div>
                <div class="mt-2 text-no-wrap text-truncate">
                  年份：{{ item.vodYear }}
                </div>
                <div class="mt-2 text-no-wrap text-truncate">
                  地区：{{ item.vodArea }}
                </div>
                <div class="mt-2 text-no-wrap text-truncate">
                  主演：{{ item.vodActor }}
                </div>
                <div class="mt-2 text-no-wrap text-truncate">
                  导演：{{ item.vodDirector }}
                </div>

                <div :class="isModel ? 'mt-2' : 'mt-5'">
                  <v-btn color="warning" small elevation="2" @click="toInfo(item.id)">立刻观看</v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <v-divider></v-divider>
      <v-pagination
          @input="send"
          v-model="pageResult.currPage"
          :total-visible="6"
          class="my-4"
          :length="pageResult.pages"
      ></v-pagination>
    </v-card>
  </div>
</template>

<script>
import {search} from "@/api/resources/video";
import {mapGetters, mapMutations} from "vuex";

export default {
  name: "result",
  data: () => ({
    title: undefined,
    searchList: [],
    pageResult: {
      currPage: 1,
      pageSize: 10,
      totalCount: 0,
      pages: 0
    },
    params: {},
    checked: 0,
    checkList:[{
      type: 1,
      name: '热度'
    },{
      type: 2,
      name: '评分'
    },{
      type: 3,
      name: '时间'
    }]
  }),
  mounted() {
    let obj = this.$route.query
    Object.keys(obj).forEach(key => {
      this.title = obj[key]
      // console.log('key:',key , 'val:', obj[key] )
    })
    this.params = this.$route.query
    this.params.sort = this.checkList[this.checked].type;
    this.send()
  },
  computed: {
    ...mapGetters(['getNode', 'getKeyList']),
    isModel() {
      return this.$vuetify.breakpoint.name === 'xs';
    },
  },
  methods: {
    ...mapMutations(['setLoading', 'clearLoading']),
    send() {
      this.setLoading();
      search({
        pageNumber: this.pageResult.currPage,
        pageSize: this.pageResult.pageSize,
        params: this.params
      }).then((req) => {
        let {total, records, pages} = req.data.data

        this.pageResult.totalCount = total
        this.pageResult.pages = pages

        records.forEach((item) => {
          item.rating = (item.vodDoubanScore * 1) / 2
        })
        this.searchList = records
      }).finally(() => {
        this.clearLoading();
      })
    },
    toInfo(id) {
      this.$router.push({
        path: '/video/info',
        query: {id: id}
      })
    },
    btnToggleChange(e){
      this.params.sort = this.checkList[e].type;
      this.send()
    }
  }
}
</script>

<style scoped>
.image-class {
  width: 100%;
  height: 100%;;
}

.title-class {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  align-items: center;
}
</style>